var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShadowNose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 129 56.4",
    style: {
      enableBackground: "new 0 0 129 56.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 64.8153,
    cy: 28.5244,
    r: 59.8728,
    gradientTransform: "matrix(0.9998 -2.081342e-02 8.325367e-03 0.3999 -0.2234 18.4662)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6806E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E18B73",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4885,
    style: {
      stopColor: "#E47984",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E99275",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.4,47.5c2.1,2.8,4.4,5.1,6.7,6.6c4,2.7,8.1,2.8,11.7,1.3c5.6-2.3,10-8.5,11-14.5c0.3-2,1.8-3.7,2.9-6.4 c0.7-1.8,1.4-3.3,1.8-3.6c2-1.6,12.6,1.9,19.3,1.5c0.5,0,1.1,0,1.6-0.1c6-0.6,13.3-3.2,16.4-0.8c0.3,0.2,1,1.2,1.7,2.4 c1.3,2.1,3.3,3.2,4.3,7c1.5,6.2,6.3,12.8,12.2,14.8c3.2,1.1,6.8,0.8,10.5-1.6c2.2-1.5,4.5-3.8,6.7-6.6c2.8-3.7,5.4-8.3,7.3-12.8 c1.5-3.6,2.5-7.2,2.9-10.4c0.5-3.9,0-7.1-1.8-9.2c-1-1.1-2-1.8-3.1-2.4c-4.6-2.2-10.3-0.1-16,1.4c-2.2,0.6-4.4,1-6.6,1.1 c-8.1,0.4-11.9,0.1-18.3-4.9c-0.8-0.7-1.7-1.4-2.6-2.2C72.6,1.6,66.2,0.8,65,0.7c-0.1,0-0.2,0-0.2,0s-7,0.2-15.1,7.4 c-2,1.8-3.8,3.2-5.4,4.2c-4.9,3.1-8.6,3.3-15.5,3c-1.8-0.1-3.5-0.4-5.3-0.8c-6.2-1.4-12.4-4-17.3-1.7C5,13.2,4,14,3.1,15.1 c-1.8,2-2.3,5.3-1.8,9.2c0.4,3.2,1.4,6.8,2.9,10.4C6,39.2,8.6,43.8,11.4,47.5z"
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      display: "none",
      overflow: "visible",
      opacity: 0.6
    },
    width: 128,
    height: 56,
    xlinkHref: "7C48A7BDE182EF62.png",
    transform: "matrix(1 0 0 1 1 0.4)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowNose);
export default __webpack_public_path__ + "static/media/ShadowNose.c3165271f533b495e2494667e91c2d49.svg";
export { ForwardRef as ReactComponent };